// NPM packages
import React from 'react';
import styled from '@emotion/styled';
import TeamMember from 'types/TeamMember';
import MemberCard from './MemberCard';

// All other imports

const Root = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gridColumnGap: '1rem',
  gridRowGap: '1rem',
});

export interface MemberGridProps {
  className?: string;
  members: TeamMember[];
}

export default function MemberGrid(
  props: MemberGridProps
): React.ReactElement | null {
  const { className, members } = props;
  return (
    <Root className={className}>
      {members.map((member) => (
        <MemberCard member={member} key={member.name} />
      ))}
    </Root>
  );
}
